import { DeliveryOrderUpdatePage } from "@/features/delivery-order/pages/DeliveryOrderUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/delivery-order/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["delivery_order.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: DeliveryOrderUpdatePage,
});
